import UploadHistoricalData from "routes/upload/historicalData/UploadHistoricalData";
import {
  Users,
  Dispensaries,
  Containers,
  FirstContainers,
  DispensarySale,
  HoseSale,
  EntryVolumeMeasurer,
  Printer,
  Backups,
  Alerts,
  Logbook,
  Dictums,
  OperationCertificates,
  FirstConfigApplication,
  ConfigurationApplication,
  OutputEmailConfig,
  HealthInformation,
  CorruptedDataVisualizer,
  VolumeMeasurerConfig,
  FirstWarehouses,
  Warehouses,
  EmailSenderConfig,
  Traspasos,
  JsonReport,
  Subscriptions,
  DictumForm,
  CheckStatusPage,
  UploadCFDIs,
  ReceptionScreen,
} from "../../../../routes/Routes";
import UpsertDistributionPoint from "../../../../routes/distributionPoints/UpsertDistributionPoint";
import { getIsCloudModeActive } from "../../../../security";
import {
  BACKUP_PERMISSION,
  DISPENSARY_PERMISSION,
  EVENTS_PERMISSION,
  EVM_PERMISSION,
  INVENTORY_CONTROL_PERMISSION,
  PRINTER_PERMISSION,
  REGISTER_PERMISSION,
  SALES_PERMISSION,
  SALE_RESUME_PERMISSION,
  USERS_PERMISSION,
  PERMISSIONS,
  EVM_DETAILS,
  DICTUM,
  INITIAL_CONTAINER,
  OPERATION_CERTIFICATE,
  CONFIG_APPLICATION,
  FIRST_CONFIG_APPLICATION,
  CORRUPTED_DATA_VISUALIZER_PERMISSION,
  INITIAL_WAREHOUSE_PERMISSIONS,
  WAREHOUSE_PERMISSIONS,
  DISTRIBUTION_POINT_PERMISSIONS,
} from "../../../../security/permissions";
import { MenuItem, MenuSection } from "./menuTypes";
import StockControl from "routes/stockControl/StockControl";
import DistributionPointsScreen from "routes/distributionPoints/DistributionPointsScreen";
import UploadJsonSATReport from "routes/upload/SATReport/UploadJsonSATReport";

const menuItems: MenuItem[] = [
  {
    section: "Control Volumétrico",
    key: DISPENSARY_PERMISSION,
    path: "/",
    component: CheckStatusPage,
    icon: "setting",
    title: "Aplicación",
    submenu: false,
    show: false,
  },
  {
    section: "Configuración Inicial",
    key: FIRST_CONFIG_APPLICATION,
    path: "/FirstConfigApplication",
    component: FirstConfigApplication,
    icon: "setting",
    title: "Configuración de aplicación",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: REGISTER_PERMISSION,
    path: "/distributionPoints/new",
    component: UpsertDistributionPoint,
    icon: "form",
    title: "Registro",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: INITIAL_WAREHOUSE_PERMISSIONS,
    path: "/firstWareHouseRegistry",
    component: FirstWarehouses,
    icon: "container",
    title: "Almacenes Iniciales",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: INITIAL_CONTAINER,
    path: "/firstContainerRegistry",
    component: FirstContainers,
    icon: "container",
    title: "Contenedores Iniciales",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/",
    component: DistributionPointsScreen,
    icon: "bank",
    title: "Puntos de Distribución",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/distributionPoints",
    component: DistributionPointsScreen,
    icon: "bank",
    title: "Puntos de Distribución",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadCfdis",
    component: UploadCFDIs,
    icon: "bank",
    title: "Carga CFDIs",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadJsonSATReport",
    component: UploadJsonSATReport,
    title: "Cargar reporte Excel SAT",
    icon: "bank",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadHistoricalData",
    component: UploadHistoricalData,
    icon: "upload",
    title: "Carga ",
    submenu: true,
    show: true,
    items: [
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadHistoricalData",
        component: UploadHistoricalData,
        title: "Carga Histórica",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadCfdis",
        component: UploadCFDIs,
        title: "Carga CFDIs",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadJsonSATReport",
        component: UploadJsonSATReport,
        title: "Cargar reporte Excel SAT",
      },
    ],
  },
  {
    section: "Instalación",
    key: WAREHOUSE_PERMISSIONS,
    path: "/wareHouse",
    component: Warehouses,
    icon: "bank",
    title: "Almacenes",
    submenu: false,
    show: true,
  },
  {
    section: "Instalación",
    key: DISPENSARY_PERMISSION,
    path: "/containers",
    component: Containers,
    icon: "container",
    title: "Contenedores",
    submenu: false,
    show: true,
  },
  {
    section: "Instalación",
    key: EVM_PERMISSION,
    path: "/entryVolumeMeasurer",
    component: EntryVolumeMeasurer,
    title: "Registro de entrada",
    icon: "dashboard",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: DISPENSARY_PERMISSION,
    path: "/dispensaries",
    component: Dispensaries,
    icon: "sliders",
    title: "Equipos",
    submenu: true,
    show: true,
    items: [
      {
        key: DISPENSARY_PERMISSION,
        path: "/dispensaries",
        component: Dispensaries,
        title: "Dispensarios",
      },
      {
        key: EVM_PERMISSION,
        path: "/entryVolumeMeasurer",
        component: EntryVolumeMeasurer,
        title: "Registro de entrada",
      },
    ],
  },
  {
    section: "Instalación",
    key: SALE_RESUME_PERMISSION,
    path: "/dispensarySale",
    component: DispensarySale,
    title: "Ventas por Dispensario",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: SALES_PERMISSION,
    path: "/hoseSale",
    component: HoseSale,
    title: "Ventas por Manguera",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: EVM_DETAILS,
    path: "/volumeMeasurerRegistries",
    component: VolumeMeasurerConfig,
    icon: "snippets",
    title: "Mediciones de nivel",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: EVM_DETAILS,
    path: "/traspasos",
    component: Traspasos,
    icon: "dashboard",
    title: "Traspasos",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: SALES_PERMISSION,
    path: "/receptions",
    component: ReceptionScreen,
    icon: "dashboard",
    title: "Reportes",
    submenu: true,
    show: true,
    items: [
      {
        key: EVM_DETAILS,
        path: "/receptions",
        component: ReceptionScreen,
        title: "Recepciones",
      },
      {
        key: EVM_DETAILS,
        path: "/traspasos",
        component: Traspasos,
        title: "Traspasos",
      },
      {
        key: SALE_RESUME_PERMISSION,
        path: "/dispensarySale",
        component: DispensarySale,
        title: "Ventas por Dispensario",
      },
      {
        key: SALES_PERMISSION,
        path: "/hoseSale",
        component: HoseSale,
        title: "Ventas por Manguera",
      },
      {
        key: EVM_DETAILS,
        path: "/volumeMeasurerRegistries",
        component: VolumeMeasurerConfig,
        title: "Mediciones de volumen",
      },
    ],
  },
  {
    section: "Instalación",
    key: DICTUM,
    path: "/dictums",
    component: Dictums as React.ComponentType<unknown>,
    icon: "snippets",
    title: "Dictamenes",
    submenu: false,
    show: true,
  },
  {
    section: "Instalación",
    key: DICTUM,
    path: "/dictum/:id",
    component: DictumForm as React.ComponentType<unknown>,
    title: "Dictamenes",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: OPERATION_CERTIFICATE,
    path: "/operationCertificates",
    component: OperationCertificates as React.ComponentType<unknown>,
    icon: "safety-certificate",
    title: "Certificados",
    submenu: false,
    show: true,
  },
  {
    section: "Instalación",
    key: INVENTORY_CONTROL_PERMISSION,
    path: "/jsonReports",
    component: JsonReport,
    title: "Reportes Json",
    submenu: false,
    show: false,
  },
  {
    section: "Instalación",
    key: INVENTORY_CONTROL_PERMISSION,
    path: "/stockControl",
    component: StockControl,
    icon: "calculator",
    title: "Control de existencias",
    submenu: true,
    show: true,
    items: [
      {
        key: INVENTORY_CONTROL_PERMISSION,
        path: "/stockControl",
        component: StockControl,
        title: "Control de existencias",
      },
      {
        key: INVENTORY_CONTROL_PERMISSION,
        path: "/jsonReports",
        component: JsonReport,
        title: "Reportes Json",
      },
    ],
  },
  {
    section: "General",
    key: PRINTER_PERMISSION,
    path: "/printer",
    component: Printer,
    icon: "printer",
    title: "Impresora",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: BACKUP_PERMISSION,
    path: "/backups",
    component: Backups,
    icon: "save",
    title: "Respaldos",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: "alerts",
    path: "/alerts",
    component: Alerts,
    title: "Alertas",
    icon: "alert",
    submenu: false,
    show: true,
  },
  {
    section: "Instalación",
    key: EVENTS_PERMISSION,
    path: "/logbook",
    component: Logbook,
    icon: "book",
    title: "Bitácora",
    submenu: true,
    show: true,
    items: [
      {
        key: EVENTS_PERMISSION,
        path: "/logbook",
        component: Logbook,
        title: "Eventos y alarmas",
      },
      {
        key: CORRUPTED_DATA_VISUALIZER_PERMISSION,
        path: "/corruptedDataVisualizer",
        component: CorruptedDataVisualizer,
        title: "Descargas fallidas",
      },
    ],
  },
  {
    section: "General",
    key: USERS_PERMISSION,
    path: "/users",
    component: Users,
    icon: "team",
    title: "Usuarios",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: PERMISSIONS,
    path: "/subscription",
    component: Subscriptions,
    icon: "desktop",
    title: "Suscripción",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: PERMISSIONS,
    path: "/healthApplication",
    component: HealthInformation,
    icon: "dashboard",
    title: "Estatus de aplicacíon",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: CONFIG_APPLICATION,
    path: "/configurationOutputEmail",
    component: OutputEmailConfig,
    icon: "mail",
    title: "Correo de salida",
    submenu: false,
    show: false,
  },
  {
    key: EVENTS_PERMISSION,
    path: "/corruptedDataVisualizer",
    component: CorruptedDataVisualizer,
    icon: "book",
    title: "Descargas fallidas",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: CONFIG_APPLICATION,
    path: "/configurationApplication",
    component: ConfigurationApplication,
    icon: "setting",
    title: "Configuración",
    submenu: true,
    show: true,
    items: [
      {
        key: CONFIG_APPLICATION,
        path: "/configurationApplication",
        component: ConfigurationApplication,
        title: "Configuración",
      },
      {
        key: CONFIG_APPLICATION,
        path: "/configurationOutputEmail",
        component: OutputEmailConfig,
        title: "Correo de salida",
      },
      {
        key: PERMISSIONS,
        path: "/healthApplication",
        component: HealthInformation,
        title: "Estatus de aplicación",
      },
      ...(typeof getIsCloudModeActive === "function" && getIsCloudModeActive()
        ? []
        : [
            {
              key: CONFIG_APPLICATION,
              path: "/emailSenderConfiguration",
              component: EmailSenderConfig,
              title: "Envío de Correos",
            },
          ]),
    ],
  },
  // Hidden items without section
  {
    key: INITIAL_WAREHOUSE_PERMISSIONS,
    path: "/distributionPoints/new",
    component: UpsertDistributionPoint,
    icon: "bank",
    title: "Nueva Instalación",
    submenu: false,
    show: false,
  },
  {
    key: SALE_RESUME_PERMISSION,
    path: "/dispensarySale",
    component: DispensarySale,
    title: "DispensarySale",
    submenu: false,
    show: false,
  },
  {
    key: SALES_PERMISSION,
    path: "/hoseSale",
    component: HoseSale,
    title: "HoseSale",
    submenu: false,
    show: false,
  },
  {
    key: EVM_DETAILS,
    path: "/volumeMeasurerRegistries",
    component: VolumeMeasurerConfig,
    icon: "snippets",
    title: "Mediciones de nivel",
    submenu: false,
    show: false,
  },
  {
    key: EVM_DETAILS,
    path: "/traspasos",
    component: Traspasos,
    icon: "dashboard",
    title: "Traspasos",
    submenu: false,
    show: false,
  },
];

export const getMenu = (
  permissions: Record<string, { read: boolean }> = {}
): MenuItem[] => {
  return menuItems.filter(
    (item) => permissions[item.key] && permissions[item.key].read === true
  );
};

export const getGroupedMenu = (
  permissions: Record<string, { read: boolean }> = {}
): MenuSection[] => {
  const filteredItems = getMenu(permissions);
  const sections: Record<string, MenuItem[]> = {};

  // Agrupar items por sección
  filteredItems.forEach((item) => {
    if (item.section) {
      if (!sections[item.section]) {
        sections[item.section] = [];
      }
      sections[item.section].push(item);
    }
  });

  // Convertir a array de secciones
  return Object.entries(sections).map(([title, items]) => ({
    title,
    items,
  }));
};
